import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { MegaphoneIcon } from '@calendly/ui/components/icons'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useEventTypeContext } from 'features/event_type_provider'
import {
  AddMembersPopup,
  closeUnassignPopup,
  fetchManagedEventType,
  isUnassignPopupOpenSelector,
  isUnassignPopupSubmittingSelector,
  UnassignPopup
} from 'features/managed_event_types'
import { fetchStatistics } from 'features/organization_statistics'

import { PanelContentContainer } from '../styles'
import { GroupSection } from './groups'
import { PeopleSection } from './people/people_section'


const NewMemberships = () => (
  <>
    <PeopleSection />
    <GroupSection />
  </>
)

export const Assign = () => {
  const { eventType, isCreation } = useEventTypeContext()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isCreation) {
      dispatch(fetchStatistics())
      dispatch(fetchManagedEventType({ id: eventType.id }))
    }
  }, [dispatch, eventType.id, isCreation])

  const isUnassignPopupOpen = useSelector(isUnassignPopupOpenSelector)
  const isUnassignPopupSubmitting = useSelector(isUnassignPopupSubmittingSelector)

  if (isCreation) {
    return (
      <PanelContentContainer>
        <ContextualBanner icon={MegaphoneIcon}>
          {I18n.t('publisher.organization.managed_event_types.assign.creation_warning')}
        </ContextualBanner>
      </PanelContentContainer>
    )
  }

  return (
    <PanelContentContainer>
      <NewMemberships />
      <AddMembersPopup />
      <UnassignPopup
        isOpen={isUnassignPopupOpen}
        submitting={isUnassignPopupSubmitting}
        onClose={() => dispatch(closeUnassignPopup())}
        id={eventType.id}
      />
    </PanelContentContainer>
  )
}
